export enum StatusEnum {
    Accepted = 'accepted',
    Active = 'active',
    Allocated = 'allocated',
    AwaitingCorrection = 'awaiting_correction',
    AwaitingRegularization = 'awaiting_regularization',
    Billed = 'billed',
    Cancelled = 'cancelled',
    Cashed = 'cashed',
    Closed = 'closed',
    Completed = 'completed',
    Deposited = 'deposited',
    DepositReceived = 'deposit_received',
    Draft = 'draft',
    DraftInt = 'draftInt',
    Duplicate = 'duplicate',
    Extracted = 'extracted',
    Followed = 'followed',
    FullyUsed = 'fully_used',
    Inactive = 'inactive',
    Justified = 'justified',
    Matched = 'matched',
    New = 'new',
    Open = 'open',
    Paid = 'paid',
    PartiallyBilled = 'partially_billed',
    PartiallyJustified = 'partially_justified',
    PartiallyMatched = 'partially_matched',
    PartiallyPaid = 'partially_paid',
    PartiallyUsed = 'partially_used',
    Pending = 'pending',
    PendingJustification = 'pending_justification',
    Posted = 'posted',
    Read = 'read',
    Refused = 'refused',
    Replaced = 'replaced',
    Sent = 'sent',
    ToValidate = 'to_validate',
    Unjustified = 'unjustified',
    Unprocessed = 'unprocessed',
    Used = 'used',
    Validated = 'validated',
    ValidatedInt = 'validatedInt',
    WrittenOff = 'written_off',
}